/**
 * @flow weak
 */
import { createStructuredSelector } from 'reselect';
import { getOrderWithCostItemQty } from '../your-order/getters';
import { getUser } from '../session/getters';

// Raw Selectors - orders
export const yourTicket = (state) => state.yourTicket;
export const selectedCostItem = (state) => state.myTickets.ui.selectedCostItem;

// connector
export default createStructuredSelector({
  yourTicket,
  yourOrder: getOrderWithCostItemQty,
  selectedCostItem,
  user: getUser
});



// WEBPACK FOOTER //
// ./src/modules/your-ticket/getters.js